import { useEffect, useRef, useState } from 'react'
import { SDrawerOrModal, SLowcodeList } from 'shj-components'
import { Form, Select, DatePicker, Row, Col, Button } from 'antd'
import dayjs from 'dayjs'
import { getSkuPriceCalculate, productSearchList } from '@/services/product'
import { config } from './config'
import ConstructionCostModal from '../constructionCostModal'

export default function NotCombinatePriceModal({
  open = false,
  setOpen = (status: boolean) => ({}),
  skuId = '',
  orgList = [],
  skuSourceType = '',
  noSearch = false,
  defaultProductId = '',
}) {
  const [formRef] = Form.useForm()
  const listRef = useRef<any>(null)
  const [loading, setLoading] = useState(false)
  const [productList, setProductList] = useState([])
  const [constructionCostModalOpen, setConstructionCostModalOpen] = useState(false)
  const [constructionCostModalRecord, setConstructionCostModalRecord] = useState<any>(null)
  const [tableConfig, setTableConfig] = useState(config)

  useEffect(() => {
    getOption()
    console.log(config, 'config')
    console.log(skuSourceType, 'skuSourceType');
    let newConfig = {...config}
    if (skuSourceType !== 'CONSTRUCTION') {
      newConfig.columns = config?.columns.filter(item => item.dataIndex !== 'action')
    }
    console.log(newConfig, 'newConfig')
    setTableConfig(newConfig)
  }, [])

  const getOption = async () => {
    const res: any = await productSearchList({
      prodType: 'PRODUCT_PACKAGE',
      enabled: true,
    })
    if (Array.isArray(res)) {
      setProductList(res)
      formRef.setFieldsValue({
        currentDate: dayjs(),
        productId: (noSearch && defaultProductId) ? defaultProductId : res[0]?.id,
        companyId: (noSearch && defaultProductId) ? orgList?.[0]?.id : ''
      })
      onSearch()
    }
  }

  const onClose = () => {
    setOpen(false)
  }

  const onSearch = () => {
    formRef.validateFields().then(async values => {
      setLoading(true)
      try {
        const res: any = await getSkuPriceCalculate({
          productId: values.productId,
          currentDate: dayjs(values.currentDate).valueOf(),
          skuId,
          companyId: values.companyId,
        })
        if (Array.isArray(res)) {
          listRef.current?.updateDataSource(res, res.length)
        }
        setLoading(false)
      } catch (err) {
        setLoading(false)
      }
    })
  }

  const clickToShowConstructionCostModal = (record: Record<string, any>) => () => {
    (record.effectiveDate = dayjs(formRef?.getFieldValue('currentDate'))?.valueOf()),
      (record.productId = formRef?.getFieldValue('productId'))
    setConstructionCostModalOpen(true)
    setConstructionCostModalRecord(record)
  }
  const renderNode = {
    customRender: {
      actionRender(_, record: Record<string, any>) {
        if (skuSourceType === 'CONSTRUCTION') {
          return (
            <Button type="link" onClick={clickToShowConstructionCostModal(record)}>
              施工成本构成
            </Button>
          )
        }
      },
    },
  }
  return (
    <div>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        antdProps={{
          footer: null,
        }}
        loading={loading}
        width={1000}
        title={'查看价格'}
      >
        <div style={{ display: noSearch ? 'none' : 'block' }}>
          <Form form={formRef}>
            <Row gutter={[20, 10]}>
              <Col span={8}>
                <Form.Item label={'适用产品'} name={'productId'} rules={[{ required: true }]}>
                  <Select
                    options={productList}
                    showSearch
                    optionFilterProp={'prodName'}
                    fieldNames={{ label: 'prodName', value: 'id' }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={'适用门店'} name={'companyId'}>
                  <Select
                    options={orgList}
                    showSearch
                    allowClear
                    optionFilterProp={'companyName'}
                    fieldNames={{ label: 'companyName', value: 'orgId' }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="日期" name="currentDate" rules={[{ required: true }]}>
                  <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} allowClear />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Button type="primary" onClick={onSearch}>
                  查询
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <SLowcodeList ref={listRef} searchMode="group" config={tableConfig} {...renderNode} search={false} />
        {constructionCostModalOpen && (
          <ConstructionCostModal
            open={constructionCostModalOpen}
            record={constructionCostModalRecord}
            onClose={() => setConstructionCostModalOpen(false)}
          ></ConstructionCostModal>
        )}
      </SDrawerOrModal>
    </div>
  )
}
